module.exports = __webpack_public_path__ + "media/img/illustrations/sticky-08b2f7326eac3c4d13ca0b31105c1c59.svg";